import { IconPlus, Button } from '@sequencehq/core-components'
import Page from 'components/Page'
import { StickyPanelFrame } from 'components/Page/StickyPanelFrame'
import { SeatSnapshotsMagicTable } from 'modules/Seats/SeatEvents/SeatEventsMagicTable'
import { Outlet } from 'react-router-dom'
import { CreateSeatSnapshotDrawer } from './CreateSnapshot/CreateSeatSnapshotDrawer'
import { ProtectedButton, usePermissions } from 'lib/rbac'

export const SeatSnapshots = () => {
  const { can } = usePermissions()

  return (
    <>
      <StickyPanelFrame>
        <Page
          title="Events"
          paddingBottom={0}
          actionElement={
            can('org.usage:create') ? (
              <CreateSeatSnapshotDrawer
                trigger={
                  <Button
                    variant="primary"
                    leadingIcon={<IconPlus color="inherit" />}
                    data-testid="seatEvents.new"
                  >
                    New seat event
                  </Button>
                }
              />
            ) : (
              <ProtectedButton permission="org.usage:create">
                <Button
                  variant="primary"
                  leadingIcon={<IconPlus color="inherit" />}
                  data-testid="seatEvents.new"
                >
                  New seat event
                </Button>
              </ProtectedButton>
            )
          }
        >
          <SeatSnapshotsMagicTable />
        </Page>
      </StickyPanelFrame>
      <Outlet />
    </>
  )
}

export default SeatSnapshots
